import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import CONFIG from 'base/constants/config';

class CDNImage extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {

    }
  }
  updateSrc(uri) {
    let src = `${this.props.host}${uri}`;
    this.setState({
      src
    })
  }

  componentDidMount() {
    this.updateSrc(this.props.uri);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.uri != this.state.uri) {
      this.updateSrc(nextProps.uri)
    }
  }

  render() {
    let { alt, className, style } = this.props;
    let otherProps = { alt, className, style };
    return (
      <img width={this.props.width} height={this.props.height} src={this.state.src} {...otherProps}/>
    );
  }
}

CDNImage.propTypes = {
  uri: PropTypes.string.isRequired
}

CDNImage.defaultProps = {
  host: CONFIG.UploadImageURL
}

export default CDNImage;



// WEBPACK FOOTER //
// ./components/UI/Image/CDNImage.jsx